import { render, staticRenderFns } from "./AudioLibrary.vue?vue&type=template&id=0b02d59f&scoped=true"
import script from "./AudioLibrary.vue?vue&type=script&lang=js"
export * from "./AudioLibrary.vue?vue&type=script&lang=js"
import style0 from "./AudioLibrary.vue?vue&type=style&index=0&id=0b02d59f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02d59f",
  null
  
)

export default component.exports